module.exports = __webpack_public_path__ + "img/11_48.8ba18ba1.png";